/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TerminiAttivoForm } from '../model/models';
import { TerminiBozzaDTO } from '../model/models';
import { TerminiBozzaForm } from '../model/models';
import { TerminiPubblicaForm } from '../model/models';
import { TerminiPubblicoAdminDTO } from '../model/models';
import { TerminiVersioneDettaglioDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface EliminaTerminiBozzaBackofficeRequestParams {
    pubblico: string;
}

export interface GetTerminiVersioneBackofficeRequestParams {
    pubblico: string;
    versione: number;
}

export interface PubblicaTerminiBozzaBackofficeRequestParams {
    pubblico: string;
    terminiPubblicaForm: TerminiPubblicaForm;
}

export interface SalvaTerminiBozzaBackofficeRequestParams {
    pubblico: string;
    terminiBozzaForm: TerminiBozzaForm;
}

export interface SetTerminiAttivoBackofficeRequestParams {
    pubblico: string;
    terminiAttivoForm: TerminiAttivoForm;
}


export interface TerminiEPrivacyGestioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Elimina la bozza dei termini di un pubblico (SUPERADMIN).
     * 
     * @endpoint delete /api/v1/gestione/termini/{pubblico}/bozza
* @param requestParameters
     */
    eliminaTerminiBozzaBackoffice(requestParameters: EliminaTerminiBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Una versione pubblicata dei termini con i testi (SUPERADMIN).
     * 
     * @endpoint get /api/v1/gestione/termini/{pubblico}/versioni/{versione}
* @param requestParameters
     */
    getTerminiVersioneBackoffice(requestParameters: GetTerminiVersioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<TerminiVersioneDettaglioDTO>;

    /**
     * Stato dei termini per i due pubblici (SUPERADMIN).
     * Sempre due elementi (ESERCENTE, CASSIERE) con interruttore, versione corrente, bozza e storico delle versioni pubblicate (senza testi).
     * @endpoint get /api/v1/gestione/termini
*/
    listTerminiBackoffice(extraHttpRequestParams?: any): Observable<Array<TerminiPubblicoAdminDTO>>;

    /**
     * Pubblica la bozza dei termini di un pubblico (SUPERADMIN).
     * Assegna il numero di versione successivo ed e\&#39; irreversibile. La prima versione di un pubblico e\&#39; sempre sostanziale. Richiede la version della bozza.
     * @endpoint post /api/v1/gestione/termini/{pubblico}/bozza/pubblica
* @param requestParameters
     */
    pubblicaTerminiBozzaBackoffice(requestParameters: PubblicaTerminiBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<TerminiPubblicoAdminDTO>;

    /**
     * Crea o aggiorna la bozza dei termini di un pubblico (SUPERADMIN).
     * version nulla crea la bozza; valorizzata la aggiorna con optimistic lock. L\&#39;HTML e\&#39; sanitizzato dal backend; testo_it senza testo visibile e\&#39; 400.
     * @endpoint put /api/v1/gestione/termini/{pubblico}/bozza
* @param requestParameters
     */
    salvaTerminiBozzaBackoffice(requestParameters: SalvaTerminiBozzaBackofficeRequestParams, extraHttpRequestParams?: any): Observable<TerminiBozzaDTO>;

    /**
     * Attiva o disattiva la raccolta dei termini di un pubblico (SUPERADMIN).
     * Attivabile solo con almeno una versione pubblicata (422 termini_attivazione_senza_versione).
     * @endpoint put /api/v1/gestione/termini/{pubblico}/attivo
* @param requestParameters
     */
    setTerminiAttivoBackoffice(requestParameters: SetTerminiAttivoBackofficeRequestParams, extraHttpRequestParams?: any): Observable<TerminiPubblicoAdminDTO>;

}
